import React from "react";
import { disablePostHogForSession } from "utils/posthog";

/**
 * App-level error boundary.
 * Catches render errors (including PostHog stack overflow during hydration)
 * and shows a fallback UI instead of a white/blank page.
 * Does NOT report to PostHog from here to avoid infinite capture loops.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Do not call posthog.capture here – it can cause "Maximum call stack size exceeded"
    // and an infinite loop (error → componentDidCatch → capture → error → …).
    if (error instanceof RangeError) {
      disablePostHogForSession();
    }
    if (process.env.NODE_ENV === "development") {
      console.error("ErrorBoundary caught:", error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: 24,
            fontFamily: "system-ui, sans-serif",
            textAlign: "center",
          }}
        >
          <h1 style={{ marginBottom: 16, fontSize: "1.25rem" }}>
            Something went wrong
          </h1>
          <p style={{ marginBottom: 24, color: "#666" }}>
            Please refresh the page to try again.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              padding: "10px 20px",
              fontSize: "1rem",
              cursor: "pointer",
              backgroundColor: "#000",
              color: "#fff",
              border: "none",
              borderRadius: 4,
            }}
          >
            Reload page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
